import { render, staticRenderFns } from "./ReceiveOrdersForm.vue?vue&type=template&id=7e06fe08&scoped=true"
import script from "./ReceiveOrdersForm.vue?vue&type=script&lang=js"
export * from "./ReceiveOrdersForm.vue?vue&type=script&lang=js"
import style0 from "./ReceiveOrdersForm.vue?vue&type=style&index=0&id=7e06fe08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e06fe08",
  null
  
)

export default component.exports